import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'inbox' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'inbox',
          name: 'inbox',
          component: () => import(/* webpackChunkName: "inbox" */ '@/views/Home/Inbox')
        },
        {
          path: 'users',
          name: 'users',
          component: () => import(/* webpackChunkName: "users" */ '@/views/Home/Users')
        },
        {
          path: 'users/:id',
          name: 'user.details',
          component: () => import(/* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails')
        },
        {
          path: 'audios',
          name: 'audios',
          component: () => import(/* webpackChunkName: "audios" */ '@/views/Home/Audios')
        },
        {
          path: 'audios/:id',
          name: 'audios.edit',
          component: () => import(/* webpackChunkName: "audios" */ '@/views/Home/Audios/Edit')
        },
        {
          path: 'categories',
          name: 'categories',
          component: () => import(/* webpackChunkName: "categories" */ '@/views/Home/Categories')
        },
        {
          path: 'comments',
          name: 'comments',
          component: () => import(/* webpackChunkName: "comments" */ '@/views/Home/Comments')
        },
        {
          path: 'reports/comments',
          name: 'reports.comment',
          component: () => import(/* webpackChunkName: "report.comments" */ '@/views/Home/Reports/Comments')
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import(/* webpackChunkName: "settings" */ '@/views/Home/Settings')
        }
      ]
    }
  ]
})
